import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const SUBMIT_STUDENT_REPORT_COMMENT_REQUEST = 'SUBMIT_STUDENT_REPORT_COMMENT_REQUEST';
export const SUBMIT_STUDENT_REPORT_COMMENT_SUCCESS = 'SUBMIT_STUDENT_REPORT_COMMENT_SUCCESS';
export const SUBMIT_STUDENT_REPORT_COMMENT_FAILURE = 'SUBMIT_STUDENT_REPORT_COMMENT_FAILURE';
export const DELETE_STUDENT_REPORT_COMMENT_REQUEST = 'DELETE_STUDENT_REPORT_COMMENT_REQUEST';
export const DELETE_STUDENT_REPORT_COMMENT_SUCCESS = 'DELETE_STUDENT_REPORT_COMMENT_SUCCESS';
export const DELETE_STUDENT_REPORT_COMMENT_FAILURE = 'DELETE_STUDENT_REPORT_COMMENT_FAILURE';

export function submitStudentReportComment(progressReportId, studentReportId,
    commentText, studentId) {
  return (dispatch, getState) => {
    const url = buildUrl(`/unit-reports/${progressReportId}/` +
        `student-reports/${studentReportId}/comments`);
    const method = 'PUT';
    const userId = getState()
        .get('singleSignOn')
        .get('user')
        .get('profile')
        .sub;
    return dispatch(submitStudentReportCommentRequest()).payload
      .then((response) => dispatch(submitStudentReportCommentSuccess(response,
        commentText,
        progressReportId,
        studentId)))
      .catch((error) => dispatch(submitStudentReportCommentFailure(error)));

    function submitStudentReportCommentRequest() {
      const request = fetch(url,
        {
          method,
          body: JSON.stringify({
            commentedByUserId: userId, // todo: set something realistic
            comments: commentText,
          }),
        }
      );
      return ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_COMMENT_REQUEST,
        payload: request,
        url,
        method,
        progressReportId,
        studentReportId,
        comments: commentText,
      });
    }

    function submitStudentReportCommentSuccess(response, comments) {
      return ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_COMMENT_SUCCESS,
        url,
        method,
        payload: response,
        comments,
        progressReportId,
        studentId,
        userId,
      });
    }

    function submitStudentReportCommentFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_COMMENT_FAILURE,
        url,
        method,
        error,
      });
    }
  };
}

export function deleteStudentReportComment(progressReportId, studentReportId, studentId) {
  return (dispatch, getState) => {
    const url = buildUrl(`/unit-reports/${progressReportId}/` +
      `student-reports/${studentReportId}/comments`);
    const method = 'DELETE';

    return dispatch(deleteStudentReportCommentRequest()).payload
      .then((response) =>
        dispatch(deleteStudentReportCommentSuccess(response, progressReportId, studentId)))
      .catch((error) => dispatch(deleteStudentReportCommentFailure(error)));

    function deleteStudentReportCommentRequest() {
      const userId = getState()
          .get('singleSignOn')
          .get('user')
          .get('profile')
          .sub;
      const request = fetch(url,
        {
          method,
          body: JSON.stringify({ deletedByUserId: userId }),
        }
      );
      return ApiCall.createAction({
        type: DELETE_STUDENT_REPORT_COMMENT_REQUEST,
        payload: request,
        url,
        method,
        progressReportId,
        studentReportId,
      });
    }

    function deleteStudentReportCommentSuccess(response) {
      return ApiCall.createAction({
        type: DELETE_STUDENT_REPORT_COMMENT_SUCCESS,
        url,
        method,
        payload: response,
        progressReportId,
        studentId,
      });
    }

    function deleteStudentReportCommentFailure(error) {
      return ApiCall.createAction({
        type: DELETE_STUDENT_REPORT_COMMENT_FAILURE,
        url,
        method,
        error,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportComment/actions.js